import clsx from 'clsx'

import spriteMarkup from 'shared/icons/sprites.svg?raw'

import { getSpriteSymbolId, mountSprite } from './lib/sprite'
import styles from './styles.module.scss'
import { AllIcons } from './types.ts'

if (typeof document !== 'undefined') {
  mountSprite(document, spriteMarkup)
}

interface Props {
  className?: string
  width?: number
  height?: number
  id: AllIcons
  style?: React.CSSProperties
  color?: string

  onClick?(e: React.MouseEvent<HTMLElement, MouseEvent>): void
}

export const AppIcon = ({
  className,
  width = 20,
  height = 20,
  id,
  color,
  onClick,
  ...props
}: Props) => {
  return (
    <span
      {...props}
      onClick={onClick}
      style={{ width, height, color }}
      className={clsx(styles.wrapper, className)}
    >
      <svg
        width={width}
        height={height}
      >
        <use href={`#${getSpriteSymbolId(id)}`} />
      </svg>
    </span>
  )
}
